import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '../../../Routes.module.css';
import styles from './DevelopTemplateCreation.module.css';
import Tile from '../../../../Components/Utils/Tile/Tile';
import TileColumn from '../../../../Components/Utils/Tile/TileColumn/TileColumn';
import TileRow from '../../../../Components/Utils/Tile/TileRow/TileRow';
import Button from '../../../../Components/Utils/Button/Button';
import { useWorkflowContext } from '../../../../Hooks/useWorkflowContext';

const DevelopTemplateCreation = () => {
  const { templateTitle } = useParams<{ templateType: string; templateId: string; templateTitle: string }>();
  const navigate = useNavigate();
  const context = useWorkflowContext();

  return (
    <div className={routes.container}>
      <div className={styles.body}>
        <h1>Develop Template Creation</h1>
        <p className={styles.subtitle}>{templateTitle}</p>
        <Tile>
          <TileColumn>
            <TileRow>
              <p className={styles.placeholder}>
                Develop workflow steps will be added here. This placeholder keeps the workflow structure ready for future expansion.
              </p>
            </TileRow>
            <TileRow>
              <Button
                style={{ maxWidth: '200px' }}
                clickHandler={() => navigate(context.getBackPath())}
              >
                Back to Templates
              </Button>
            </TileRow>
          </TileColumn>
        </Tile>
      </div>
    </div>
  );
};

export default DevelopTemplateCreation;






